/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { getStyleOverrides } from '@/utils/getStyleOverrides';
import { ThemeOptions } from '@mui/material/styles';

export const Link: ThemeOptions = {
	components: {
		MuiLink: {
			defaultProps: {
				// The props to change the default for.
				underline: 'hover',
				color:'#000'
			},
			styleOverrides: {
				root: getStyleOverrides({
					styles: {
						"&:focus-visible": {
							outlineOffset: 4,
							borderRadius: 0.2,
						}
					},
				}),
			},
		},
		MuiButton: {
			styleOverrides: {
				root: getStyleOverrides({
					styles: {
						"&:focus-visible": {
							outline: `2px solid #000`,
							outlineOffset: 4,
							borderRadius: 0.2,
						}
					},
				}),
			},
		},
	},
};
